var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tab flex_v align-items-center justify-content-center",staticStyle:{"cursor":"pointer"},attrs:{"href":_vm.tab.area01_ProductURL,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.tab.area01_ProductIcon}}),_c('p',[_vm._v(_vm._s(_vm.tab.area01_ProductName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }